import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const initialForm = {
  prenume: "", nume: "", cnp: "", tara: "România", judet: "", oras: "",
  email: "", telefon: "", membru: false, voluntar: false, membruVoluntar: false,
};

const AddPersonModal = ({ show, onHide, onSave }) => {
  const [form, setForm] = useState(initialForm);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleTermsChange = (e) => {
    setAcceptTerms(e.target.checked);
  };

  const handleSubmit = () => {
    if (!acceptTerms) return; // Protecție suplimentară
    onSave(form);
    setForm(initialForm);
    setAcceptTerms(false);
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="neumorph-modal">
      <Modal.Header closeButton>
        <Modal.Title className="text-primary-dark">Înscriere ca Membru / Voluntar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {["prenume", "nume", "cnp", "judet", "oras", "email", "telefon"].map((field) => (
            <Form.Group key={field} className="mb-3">
              <Form.Label>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
              <Form.Control
                type="text"
                name={field}
                value={form[field]}
                onChange={handleChange}
              />
            </Form.Group>
          ))}

          <Form.Group className="mb-3">
            <Form.Label>Țara</Form.Label>
            <Form.Control
              as="select"
              name="tara"
              value={form.tara}
              onChange={handleChange}
            >
              <option value="România">România</option>
              <option value="Diaspora">Diaspora</option>
            </Form.Control>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Membru"
              name="membru"
              checked={form.membru}
              onChange={handleChange}
            />
            <Form.Check
              type="checkbox"
              label="Voluntar"
              name="voluntar"
              checked={form.voluntar}
              onChange={handleChange}
            />
            <Form.Check
              type="checkbox"
              label="Membru și Voluntar"
              name="membruVoluntar"
              checked={form.membruVoluntar}
              onChange={handleChange}
            />
          </Form.Group>

          {/* Checkbox pentru acceptarea termenilor */}
          <Form.Group className="mb-2">
            <Form.Check
              type="checkbox"
              id="acord"
              checked={acceptTerms}
              onChange={handleTermsChange}
              required
              label={
                <label
                  className="form-check-label"
                  htmlFor="acord"
                  style={{ marginBottom: 0 }}
                >
                  Sunt de acord cu <strong>
                    <a
                      href="/gdpr"
                      className="termeni-link"
                      style={{ color: "#d63384", textDecoration: "underline", fontWeight: 500 }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      termenii și condițiile PRDP
                    </a>
                  </strong>, inclusiv cu prelucrarea datelor personale*
                  <br />
                  <small className="text-muted">
                    Datele tale vor fi procesate în conformitate cu Regulamentul (UE) 2016/679
                  </small>
                </label>
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Închide</Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!acceptTerms}
        >
          Salvează
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPersonModal;
